module.exports = __webpack_public_path__ + "static/media/story-12.66e3d87b.jpeg";